// Org content-tag CRUD + bulk-tag content endpoints.
//
// Routes:
//   GET    /orgs/content_tags
//   POST   /orgs/content_tags
//   PUT    /orgs/content_tags/:id
//   DELETE /orgs/content_tags/:id
//   POST   /orgs/contents/bulk_tag

export const createListContentTagsRequest = () => ({
  url: "/orgs/content_tags",
  method: "GET",
});

export const createCreateContentTagRequest = (data) => ({
  url: "/orgs/content_tags",
  method: "POST",
  data,
});

export const createUpdateContentTagRequest = (id, data) => ({
  url: `/orgs/content_tags/${id}`,
  method: "PUT",
  data,
});

export const createDeleteContentTagRequest = (id) => ({
  url: `/orgs/content_tags/${id}`,
  method: "DELETE",
});

export const createBulkTagContentsRequest = (data) => ({
  url: "/orgs/contents/bulk_tag",
  method: "POST",
  data,
});
